import React from 'react';

import { FCC } from '@zazume/zzm-base';
import { BooleanHelper } from '@zazume/zzm-utils';

import { useAuth } from '../../contexts/AuthProvider';

interface CanInDefaultOrganizationProps {
  if?: boolean;
}

export const CanInDefaultOrganization: FCC<CanInDefaultOrganizationProps> = props => {
  const { organization } = useAuth();

  if (BooleanHelper.isFalse(props.if)) {
    return null;
  }

  if (!organization?.isDefaultOrganization) {
    return null;
  }

  return <>{props.children}</>;
};
